import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import { Tab } from '../../../BulkContext';

import CustomFields from './CustomFields';
import SummaryPane from './SummaryPane';

import classes from '../body.module.css';

export interface Props {
  tab: Tab;
}

const WorkInfoBody = ({ tab }: Props) => {
  const showFields = hasRolePermissions(ROLE_SETS.INSPECTOR);

  return (
    <div className={classes.body}>
      <div className={classes.bodyHeader}>
        <div className={classes.bodyHeaderTitle}>{tab.label}</div>
      </div>
      <div className={classes.bodyContent}>
        <SummaryPane />
        {showFields && <CustomFields />}
      </div>
    </div>
  );
};

export default WorkInfoBody;
